import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import AuthCallback from "@/components/AuthCallback";
import HomePage from "@/pages/HomePage";
import ResultsPage from "@/pages/ResultsPage";
import SuccessPage from "@/pages/SuccessPage";
import Dashboard from "@/pages/Dashboard";
import OccasionsPage from "@/pages/OccasionsPage";

function AppRoutes() {
  const location = useLocation();
  // Process OAuth session_id FIRST (synchronously during render) to avoid race conditions
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/results" element={<ResultsPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/occasions" element={<OccasionsPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
